import styled from '@emotion/styled'
import { Flex } from '@collable/ui'
import type { ElementType } from 'react'
import type { PolymorphicComponentProps } from '@/types/utils/asProps'

type ContentBoxOwnProps = {
  children: React.ReactNode
  gap?: number
  align?: 'center' | 'flex-start' | 'flex-end'
}

type ContentBoxProps<T extends ElementType> = ContentBoxOwnProps & PolymorphicComponentProps<T>

const ContentBox = <T extends ElementType>({
  children,
  gap = 0,
  as = 'section' as T,
  align,
  ...props
}: ContentBoxProps<T>) => {
  return (
    <Container as={as} direction="column" gap={gap} alignItems={align} {...props}>
      {children}
    </Container>
  )
}

export default ContentBox

const Container = styled(Flex)`
  width: 480px;
  background-color: ${({ theme }) => theme.common.commonWhite};
  padding: 40px;
  border-radius: 20px;
`
